import MultiColumnRowBase from './MultiColumnRowBase';

const MultiColumnRow = ({ data, ...rest }) => {
	const colCount = data.col_count || 4;
	const className = data.class_name || (colCount === 4 ? 'col-md-3' : 'col');
	if (!data.child_items) {
		// eslint-disable-next-line no-param-reassign
		data.child_items = Array.from({ length: colCount }, () => null);
		data.is_container = true;
	}
	return <MultiColumnRowBase {...rest} className={className} data={data} />;
};

export default MultiColumnRow;
